import { FromObservable } from './FromObservable';
export var from = FromObservable.create;
//# sourceMappingURL=from.js.map